export enum FloorElevationSource {
  Root,
  Ifc
}
